import SocialMediaBrand from './SocialMediaBrand';

export default SocialMediaBrand;
